import { apiClient } from "../apiClient";
export const QUOC_TICH_ENDPOINT = "quoc-tich";
export const quocTichApi = {
  SelectAll: () => apiClient.get(`${QUOC_TICH_ENDPOINT}`),
};
